import { create } from 'zustand';
import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';
import { isInCapacitorPlatform } from '@fabric-app/compat/capabilities/platform';

const useModalTopUp = create()(delayedTrackZustand((set) => ({
  isOpen: false,
  open: () => set({
    isOpen: true
  }),
  close: () => set({
    isOpen: false
  }),
  setOpen: (isOpen) => set({
    isOpen
  })
}), "modal-top-up"));
const topUpModal = {
  open: useModalTopUp.getState().open,
  close: useModalTopUp.getState().close,
  setOpen: useModalTopUp.getState().setOpen,
  isAvailable: () => !isInCapacitorPlatform()
};

export { topUpModal, useModalTopUp };
//# sourceMappingURL=modalTopUpStore.js.map
